import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-description',
    templateUrl: './detail-description.component.html',
    styleUrls: ['./detail-description.component.scss'],
    standalone: false,
})
export class DetailDescriptionComponent {
    @Input()
    public title?: string;

    @Input()
    public tags?: Array<string>;

    public safeHtmlDescription?: SafeHtml;

    constructor(
        private readonly _domSanitizer: DomSanitizer,
    ) {
    }

    @Input()
    public set htmlDescription(description: string) {
        this.safeHtmlDescription = this._domSanitizer.bypassSecurityTrustHtml(description);
    }
}
